module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": "success",
      "button-text": _vm.addSuffix((_vm.totals + 1), false) + ' Option',
      "heading": "New Option",
      "buttonIcon": "fa fa-plus",
      "disableButton": _vm.disableButton
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel
    }
  }, [_c('acquire-details', {
    attrs: {
      "row-data": _vm.rta,
      "site-data": _vm.siteData,
      "adding": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f6d5b5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/OptionAction.vue
// module id = 1361
// module chunks = 0